import React from 'react';
import { Card, Col, Row } from 'antd';
import ParkingSubComponent from '../Components/Profile/ParkingSubComponent';
import { AnimatePresence, motion } from "framer-motion";

const Parking = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
    >
      <Row
        className='layout'
        justify='center'
        align='center'
      >
        <Col>
          <AnimatePresence mode='wait' initial={false}>
            <Card className='profile-card parking-page-card' bordered={false}>
              <ParkingSubComponent />
            </Card>
          </AnimatePresence>
        </Col>
      </Row>
    </motion.div>
  );
};

export default Parking;
